import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 149671 195640"
    {...props}
  >
    <path
      d="M59159 151840H24599c-8186 0-14334-1859-18448-5574C2035 142551 0 137506 0 131091c0-1636 310-3273 884-4957 621-1680 1505-3448 2743-5308 1195-1859 2433-3671 3763-5398 1282-1725 2875-3847 4778-6324l46991-62850v42536l-25226 34115h25226v28935zM90512 5493c495-517 968-988 1423-1420C94854 1373 98306 0 102375 0c13140 0 19690 7521 19690 22564v100341h5574c6638 0 11990 884 16015 2700 4026 1815 6017 5797 6017 11901 0 4998-1637 8628-4910 10926-3317 2258-8230 3408-14777 3408h-7919v24114c0 6634-1461 11591-4424 14820-2922 3229-6860 4866-11770 4866-4822 0-8760-1681-11722-5001-1687-1887-2904-4292-3637-7202V5493z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
